<script>
    import {tagAddInList, tagRemoveInList} from '@/scripts/tag.js';
    import TagContainer from '@/components/base-components/TagContainer.vue';


    export default {
        data() {
            return {
                tagValue: '',
            }
        },
        components: {
            TagContainer: TagContainer
        },
        computed: {
            selectTag() { return this.$store.getters.SELECT_TAG },
        },
        methods: {
            async addTag() {
                let newSelectTag = await tagAddInList(this.selectTag, this.tagValue);
                this.tagValue = '';
                await this.$store.commit('SELECT_TAG', newSelectTag);
            },
            async RemoveTag(tagID) {
                let newSelectTag = await tagRemoveInList(this.selectTag, tagID);
                await this.$store.commit('SELECT_TAG', newSelectTag);
            }
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Tags:</label>
        <div class="left_sub_multi_container mt_5">
            <input
                v-model="tagValue" 
                type="text" 
                list="tagList"
                class="right_input"
            >
            <button 
                @click="addTag"
                class="button_blue_100 ml_10"
            >Add</button>
        </div>

        <div class="tag_container mt_10">
            <TagContainer 
                v-for="(tagValue, tagIndex) in selectTag" :key="tagIndex"
                tag-color="tag"
                :tag-i-d="tagValue"
                @deleteTag = "RemoveTag"
            />
        </div>
    </div>
</template>